import { Col, Row, Tooltip } from 'antd';
import React from 'react';
import { Currency, Icon } from '@common/components';
import { formatSecondsToDuration } from '@timekeeping/services';

type ChangeLine = {
  current?: boolean;
  payCode: string;
  hours: number | string;
  billingRate: number | string;
  hasCustomRate?: boolean;
  billingAmount: number | string;
  showEstimationSymbol?: boolean;
};

export const SimpleDiffLine = (props: ChangeLine) => {
  const renderCurrency = (value: string | number) =>
    typeof value === 'string' ? value : <Currency value={value} />;

  const renderLabel = (
    value: string | number | JSX.Element,
    className: string
  ) => {
    return props.current ? (
      <strong className={className}>{value}</strong>
    ) : (
      <s className={className}>{value}</s>
    );
  };

  return (
    <div className="SimpleDiffLine table-row">
      <Row gutter={[16, 0]}>
        <Col span={6}>{renderLabel(props.payCode, 'diff-pay-code')}</Col>
        <Col span={6}>
          <Row>
            {renderLabel(renderCurrency(props.billingRate), 'billing-rate')}
            {props.hasCustomRate && (
              <Tooltip title="This is a custom Billing Rate that is different from the original Pay Code.">
                <div style={{ marginLeft: 5 }}>
                  <Icon
                    kind="light"
                    icon="circleInfo"
                    color="midnightLighter"
                  />
                </div>
              </Tooltip>
            )}
          </Row>
        </Col>
        <Col span={6}>
          {renderLabel(
            typeof props.hours === 'number'
              ? formatSecondsToDuration(props.hours)
              : props.hours,
            'diff-hours'
          )}
        </Col>
        <Col span={6}>
          {renderLabel(renderCurrency(props.billingAmount), 'billing-amount')}
          {props.showEstimationSymbol && '*'}
        </Col>
      </Row>
    </div>
  );
};

SimpleDiffLine.Empty = () => (
  <SimpleDiffLine
    hours="N/A"
    billingAmount="N/A"
    billingRate="N/A"
    payCode="N/A"
  />
);
